// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1srH8","addWidgetButton":"Header_addWidgetButton__2t4Wz","dashboardTabs":"Header_dashboardTabs__2-H2q","active":"Header_active__1dtsw"};